<template>
  <div class="channel-commission">
<!--    &lt;!&ndash; 页面头部 &ndash;&gt;-->
<!--    <div class="page-header">-->
<!--      <div class="header-left">-->
<!--        <h2 class="page-title"><i class="el-icon-s-cooperation"></i> 佣金配置</h2>-->
<!--        <span class="page-desc">管理渠道佣金规则、线路佣金配置及经营概览数据</span>-->
<!--      </div>-->
<!--      <div class="header-right">-->
<!--        <el-button icon="el-icon-refresh" size="small" @click="refreshCurrentTab">刷新</el-button>-->
<!--      </div>-->
<!--    </div>-->

    <!-- Tab标签页 -->
    <div class="section-title"><i class="el-icon-s-cooperation"></i> 佣金配置</div>
    <el-card shadow="never" class="main-card">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="commission-tabs">
        <!-- Tab 1: 佣金概览 -->
        <el-tab-pane name="overview">
          <span slot="label"><i class="el-icon-data-analysis"></i> 佣金概览</span>
          <commission-overview ref="commissionOverview"></commission-overview>
        </el-tab-pane>

        <!-- Tab 2: 佣金规则 -->
        <el-tab-pane name="rules">
          <span slot="label"><i class="el-icon-setting"></i> 佣金规则</span>
          <commission-rule ref="commissionRule"></commission-rule>
        </el-tab-pane>

        <!-- Tab 3: 线路配置 -->
        <el-tab-pane name="lines">
          <span slot="label"><i class="el-icon-guide"></i> 线路配置</span>
          <line-config ref="lineConfig"></line-config>
        </el-tab-pane>
      </el-tabs>
    </el-card>

  </div>
</template>

<script>
import CommissionOverview from './components/commissionOverview.vue'
import CommissionRule from './components/commissionRule.vue'
import LineConfig from './components/lineConfig.vue'

export default {
  name: 'channelCommission',
  components: {
    CommissionOverview,
    CommissionRule,
    LineConfig
  },
  data() {
    return {
      activeTab: 'overview'
    }
  },
  computed: {
    commissionTypeOptions() {
      return this.$const.CHANNEL_COMMISSION_TYPE || []
    }
  },
  created() {
  },
  methods: {
    // Tab切换
    handleTabClick(tab) {
      if (tab.name === 'overview' && this.$refs.commissionOverview) {
        this.$nextTick(() => {
          this.$refs.commissionOverview.refresh()
        })
      } else if (tab.name === 'lines' && this.$refs.lineConfig) {
        this.$nextTick(() => {
          this.$refs.lineConfig.refresh()
        })
      }
    },
    refreshCurrentTab() {
      if (this.activeTab === 'overview') {
        if (this.$refs.commissionOverview) {
          this.$refs.commissionOverview.refresh()
        }
      } else if (this.activeTab === 'rules') {
        if (this.$refs.commissionRule) {
          this.$refs.commissionRule.refresh()
        }
      } else if (this.activeTab === 'lines') {
        if (this.$refs.lineConfig) {
          this.$refs.lineConfig.refresh()
        }
      }
    },
    // 线路相关
    async getLineList(params) {
      const res = await this.$axios.get('/api/v1/channel/line/list', params)
      return res
    },
    handleEditLine(row) {
      this.currentLine = { ...row }
      this.lineForm = {
        supportChannel: row.supportChannel || false,
        commissionType: row.commissionType || 2,
        commissionValue: row.commissionValue || 5
      }
      this.lineDialogVisible = true
    },
    async handleSaveLine() {
      this.$refs.lineForm.validate(async (valid) => {
        if (valid) {
          this.lineLoading = true
          try {
            const res = await this.$axios.post('/api/v1/channel/line/commission/update', {
              lineId: this.currentLine.id,
              ...this.lineForm
            })
            if (res.code === 1) {
              this.$message.success('保存成功')
              this.lineDialogVisible = false
              this.$refs.lineCustomTable.getList()
            }
          } finally {
            this.lineLoading = false
          }
        }
      })
    },
    handleSelectionChange(val) {
      this.selectedLines = val
    },
    handleBatchSet() {
      this.batchDialogVisible = true
    },
    async handleSaveBatch() {
      this.$refs.batchForm.validate(async (valid) => {
        if (valid) {
          this.batchLoading = true
          try {
            for (const line of this.selectedLines) {
              await this.$axios.post('/api/v1/channel/line/commission/update', {
                lineId: line.id,
                ...this.batchForm
              })
            }
            this.$message.success('批量设置成功')
            this.batchDialogVisible = false
            this.$refs.lineCustomTable.getList()
          } finally {
            this.batchLoading = false
          }
        }
      })
    },
    calculateCommission(row) {
      if (!row.supportChannel) return 0
      if (row.commissionType === 1) {
        return row.commissionValue
      } else {
        return (row.price * row.commissionValue / 100).toFixed(2)
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import '../channel.less';

// 页面容器
.channel-commission {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 主卡片
.main-card {
  flex: 1;
  overflow: hidden;
  
  /deep/ .el-card__body {
    padding: 0;
    height: 100%;
  }
}

// Tab样式
.commission-tabs {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  /deep/ .el-tabs__header {
    margin: 0;
    padding: 0 16px;
    border-bottom: 1px solid #EBEEF5;
    flex-shrink: 0;
  }
  
  /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }
  
  /deep/ .el-tabs__content {
    flex: 1;
    overflow: hidden;
  }
  
  /deep/ .el-tab-pane {
    padding: 16px;
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    background: #f5f7fa;
  }
}
</style>
